import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';

import { CheckoutActionHandler, CheckoutState } from './checkout';
import { FlowActionHandler, FlowState } from './flow';
import { ParamsActionHandler, ParamsState } from './params';
import { PaymentActionHandler, PaymentState } from './payment';
import { SettingsActionHandler, SettingsState } from './settings';
import { SplitState } from './split';
import { StepsActionHandler, StepsState } from './steps';

@NgModule({
  imports: [
    CommonModule,

    NgxsModule.forFeature([
      CheckoutState,
      FlowState,
      ParamsState,
      PaymentState,
      SettingsState,
      StepsState,
      SplitState,
    ]),
  ],
  exports: [
    NgxsModule,
  ],
})
export class StoreModule {
  constructor(
    private readonly checkoutActionHandler: CheckoutActionHandler,
    private readonly flowActionHandler: FlowActionHandler,
    private readonly paramsActionHandler: ParamsActionHandler,
    private readonly stepsActionHandler: StepsActionHandler,
    private readonly paymentActionHandler: PaymentActionHandler,
    private readonly settingsActionHandler: SettingsActionHandler,
  ) {}
}
